import { all, fork, put, takeLatest, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";
import { fetchCitiesApi } from "redux/city/api";
import { fetchStatesApi } from "redux/state/api";
import { FilterMetadata } from "redux/types";
import { fetchPincodeApi } from "redux/customer/api";
import { FetchCityStateByZipRequest, ZipReduxTypes } from "./types";

function pickNameMatch(records: any, name: string) {
  if (!records || records.length === 0) {
    return undefined;
  }

  const normalized = name.trim().toLowerCase();
  let match = records.find((record: any) => record?.name?.trim().toLowerCase() === normalized);

  if (!match) {
    match = records.find((record: any) => record?.name?.trim().toLowerCase().includes(normalized) || normalized.includes(record?.name?.trim().toLowerCase()));
  }

  if (!match) {
    match = records[0];
  }

  return match;
}

function readRecords(response: any) {
  return response?.data?.data?.records || [];
}

function* fetchCityStateByZip({ payload }: FetchCityStateByZipRequest): SagaIterator {
  try {
    const pincodeResponse = yield call(fetchPincodeApi, payload);
    const record = pincodeResponse?.data?.data?.[0];

    if (!record?.district || !record?.stateName) {
      yield put({
        type: ZipReduxTypes.FETCH_CITY_STATE_BY_ZIP_ERROR,
        payload: { error: "not-found", zip: payload }
      });
      return;
    }

    const cityName = record.district;
    const stateName = record.stateName;
    var state: any = { name: stateName };
    var city: any = { name: cityName };

    try {
      var stateFilters: FilterMetadata = {
        filters: {}
      };
      stateFilters.pgsz = 20;
      stateFilters.filters = {
        name: [
          {
            value: stateName,
            matchMode: "containsStr",
            operator: "and"
          }
        ],
        APPROVED_VERSION: [
          {
            value: true,
            matchMode: "eqBool",
            operator: "and"
          }
        ]
      };

      const stateResponse = yield call(fetchStatesApi, stateFilters);
      const stateMatch = pickNameMatch(readRecords(stateResponse), stateName);
      if (stateMatch) {
        state = stateMatch;
      }

      var cityFilters: FilterMetadata = {
        filters: {}
      };
      cityFilters.pgsz = 20;
      cityFilters.filters = {
        name: [
          {
            value: cityName,
            matchMode: "containsStr",
            operator: "and"
          }
        ],
        APPROVED_VERSION: [
          {
            value: true,
            matchMode: "eqBool",
            operator: "and"
          }
        ]
      };

      if (state.id) {
        cityFilters.filters["stateId"] = [
          {
            value: state.id,
            matchMode: "eqStr",
            operator: "and"
          }
        ];
      }

      const cityResponse = yield call(fetchCitiesApi, cityFilters);
      const cityMatch = pickNameMatch(readRecords(cityResponse), cityName);
      if (cityMatch) {
        city = cityMatch;
      }
    } catch (masterError: any) {
      // Keep names from the PIN response if city/state masters cannot be matched.
    }

    yield put({
      type: ZipReduxTypes.FETCH_CITY_STATE_BY_ZIP_SUCCESS,
      payload: { data: { zip: payload, city, state } }
    });
  } catch (error: any) {
    yield put({
      type: ZipReduxTypes.FETCH_CITY_STATE_BY_ZIP_ERROR,
      payload: { error: error, zip: payload }
    });
  }
}

export function* watchFetchCityStateByZip() {
  yield takeLatest(ZipReduxTypes.FETCH_CITY_STATE_BY_ZIP, fetchCityStateByZip);
}

function* pincodeSaga() {
  yield all([fork(watchFetchCityStateByZip)]);
}

export default pincodeSaga;
